import React, {useContext} from 'react';

import {SmartInput} from 'src/components/smart-input';
import {MessageContext} from 'src/contexts/message-context';
import {ValidationContext} from 'src/contexts/validation-context';

type Props = {
    profileName: string,
    isPrimary: boolean,
    onSetName: (value: string) => void,
};

export const ProfileName = ({profileName, isPrimary, onSetName}: Props) => {
    const {getErrorsByControlId} = useContext(ValidationContext);
    const {setErrorMessage} = useContext(MessageContext);

    return (
        <SmartInput
            disabled={isPrimary}
            error={getErrorsByControlId('profile-name').length
                ? getErrorsByControlId('profile-name')[0].message
                : undefined}
            value={profileName}
            onChange={onSetName}
            onErrorClick={(error: string) => setErrorMessage(error)}
            maxLength={128}
        />
    );
};
